import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CatalogCard } from '../../interfaces/catalog-card';

@Component({
  selector: 'app-catalog-card',
  templateUrl: './catalog-card.component.html',
  styleUrls: ['./catalog-card.component.scss', './catalog-card.component.en.scss'],
})
export class CatalogCardComponent {
  @Input() cardData: CatalogCard | any;
  @Output() favoriteChange = new EventEmitter<number>();

  
  checkIfContactInfoExists(): boolean {
    return this.cardData.fullName || this.cardData.email || this.cardData.phone;
  }

  onFavoriteClick(evt: Event) {
    evt.stopPropagation();
    evt.preventDefault();

    const id = this.cardData?.nodeId;
    if (!id) return;

    this.favoriteChange.emit(id);
  }
}
